import { render } from "./Footer.vue?vue&type=template&id=a2cd5e3e&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=a2cd5e3e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a2cd5e3e"

export default script